import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//icons
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete, AiOutlineEye } from 'react-icons/ai';
import { BsSearch } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
//api
import { getAllBookOfTheMonthItems } from 'api/libelista';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import SearchTable from 'components/backoffice/table/SearchTable';

const colsBooksOfMonth = ['Título', 'Párrafo distinguido', 'Descripción', ''];

const BooksOfMonth = () => {
  const navigate = useNavigate();
  const [listBooksOfMonth, setListBooksOfMonth] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [noResults, setNoResults] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(['backoffice']);

  const query = {
    search: '',
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListBooksOfMonth = async () => {
    setIsLoading(true);
    const { data, status } = await getAllBookOfTheMonthItems(queryString);
    if (status === 200 && data?.results.length > 0) {
      setListBooksOfMonth(data?.results);
      setNoResults(false);
    } else {
      setListBooksOfMonth([]);
      setNoResults(true);
    }
    setIsLoading(true);
  };

  useEffect(() => {
    getListBooksOfMonth();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/books-of-the-month');
  };

  return (
    <div className="h-100 ml-70">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Entradas de libros del mes</h1>
      </div>

      <div className=" d-flex justify-content-between">
        <SearchTable value={inputValue} handleClear={handleClear} />
        <Col md={1} className="text-end mt-3">
          <Button color={'primary'}>{t('crear')}</Button>
        </Col>
      </div>
      <CustomTable cols={colsBooksOfMonth} noResults={noResults} page={1}>
        {listBooksOfMonth &&
          listBooksOfMonth.map((listBookOfMonth, index) => {
            return (
              <tr key={listBookOfMonth.id}>
                <td className="text-light">{listBookOfMonth.title}</td>
                <td className="text-light">{listBookOfMonth.featured_paragraph}</td>
                <td className="text-light">{listBookOfMonth.description}</td>
                <td className="text-light item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default BooksOfMonth;
